import { PLAY_VIDEO } from '../actions/media-player';

const initialState = {
    videos: [],
};

export function reducer(state = initialState, action = {}) {
    switch (action.type) {
        case PLAY_VIDEO:
            return {
                videos: state.videos.find((item) => item.exerciseId === action.payload.exerciseId)
                    ? state.videos
                    : [
                          ...state.videos,
                          {
                              exerciseId: action.payload.exerciseId,
                              playTouched: true,
                          },
                      ],
            };
        default:
            return state;
    }
}
